











































import { defineComponent, computed } from '@vue/composition-api';
import { socialBtns, socialAuth, useRegister } from './auth';
import { useRegisterFields } from './user_info';
import { authRedirection, loadProductType } from '@ligo/bv-flow/services';
import { ApiService, ChatBase } from '@ligo/shared/utils';
import { Analytic } from '../../analytics';
import RegisterForm from './RegisterForm.vue';
import NewContactCard from '../../components/base/NewContactCard.vue';
import BvAlertBanner from '../../components/base/BvAlertBanner.vue';
import { analyticGTMSelectSignUp } from '../../hooks/useBvFlowGTM.hooks';
import { RESOURCES, UserInfo } from '@ligo/bv-flow/store';

export default defineComponent({
  name: 'Register',
  components: {
    RegisterForm,
    BvAlertBanner,
    NewContactCard
  },
  props: {
    redirectUrl: {
      type: String
    },
    productType: {
      type: String
    },
    companyName: {
      type: String
    }
  },
  setup(props, { root }) {
    Analytic.registerPage('Register');

    const loggedIn = computed(() => {
      return root.$store.state.authentication.accessToken ? true : false;
    });

    const handler = useRegister();

    if (loggedIn.value) {
      authRedirection(props.redirectUrl, props.productType);
    }
    const { register_fields } = useRegisterFields();
    const first_row = [register_fields.value[0], register_fields.value[1]];
    const lower_fields = register_fields.value.slice(2);

    const performRegister = async (checkParams) => {
      const result: boolean = await handler.performRegister(
        register_fields.value,
        checkParams
      );
      if (result) {
        analyticGTMSelectSignUp(props.productType || loadProductType());
        Analytic.registerUser(root.$store.state.authentication.accessToken);

        ApiService.get(RESOURCES.ME)
          .then((response) => {
            const userInfo = response as UserInfo;
            const user = userInfo.data;

            ChatBase.initConversationService();
            ChatBase.identifyUser(user.uuid, user.user_hash, {
              name: `${user.firstname} ${user.lastname}`,
              email: user.email,
              phonenumber: user.phone
            });
          })
          .catch((e) => {
            ChatBase.initConversationService();
            console.error(
              `There was an error identifying the user in ChatBase: ${e}`
            );
          });

        authRedirection(props.redirectUrl, props.productType);
      }
    };
    const authErrors = computed(() => {
      return root.$store.state.authentication.authenticationError;
    });

    const performSocialAuth = (btn) => {
      if (props.redirectUrl) {
        socialAuth(btn, props.redirectUrl);
      } else {
        const product_type = loadProductType();
        if (product_type) {
          socialAuth(btn, product_type);
        } else {
          socialAuth(btn);
        }
      }
    };

    const registerError = computed(
      () => root.$store.getters['authentication/authenticationError']
    );

    const goToLogin = () => {
      cleanErrors();
      root.$router.push({
        name: 'login',
        query: {
          redirect_url: props.redirectUrl,
          product_type: props.productType
        }
      });
    };

    const cleanErrors = () => {
      root.$store.commit('authentication/cleanErrors');
    };

    const goBack = () => {
      let redirect_url = root.$route.query['redirect_url'].toString();
      if (redirect_url.includes('/billing')) {
        redirect_url = redirect_url.replace('/billing', '');
      }
      void root.$router.push(redirect_url);
    };

    const showGoBack = () => {
      if (root.$route.query['redirect_url']) return true;
    };

    return {
      performRegister,
      authErrors,
      socialBtns,
      socialAuth,
      first_row,
      lower_fields,
      performSocialAuth,
      registerError,
      cleanErrors,
      goToLogin,
      goBack,
      showGoBack
    };
  }
});
